// import React from "react";
// import InputFactory from "../../../../../components/InputFactory";
// import { saveFileUseCase } from "../../../../../usecases/file";

// // Constants
// const CURRENCY_FORMAT_OPTIONS = {
//   minimumFractionDigits: 2,
//   maximumFractionDigits: 2,
// };

// // Helper functions
// const formatCurrency = (amount) =>
//   `₱${Number(amount || 0).toLocaleString(undefined, CURRENCY_FORMAT_OPTIONS)}`;

// const PaymentSummary = ({
//   paymentDate,
//   filteredData,
//   paymentUpload,
//   handlePaymentDateChange,
//   handleFileChange,
//   setViewBucket,
//   viewBucket,
//   handleDeleteRequest,
//   setZoomSrc,
// }) => (
//   <div className="mt-5">
//     <div className="col-sm-2 mb-3">
//       <input
//         className="form-control"
//         type="date"
//         value={paymentDate}
//         disabled={filteredData.length === 0}
//         onChange={handlePaymentDateChange}
//       />
//     </div>
//     <h4>
//       💳<span style={{ color: "#83c14a" }}> Payment</span> Type Summary
//     </h4>
//     <div className="table-responsive">
//       <table className="table table-bordered">
//         <thead className="table-light">
//           <tr>
//             {["Payment Type", "Count", "Total Sales", "Action"].map(
//               (header, index) => (
//                 <th
//                   key={header}
//                   className={
//                     index === 1 ? "text-center" : index === 2 ? "text-end" : ""
//                   }
//                   style={{
//                     backgroundColor: "#83c14a",
//                     color: "white",
//                     marginBottom: 12,
//                   }}
//                 >
//                   {header}
//                 </th>
//               )
//             )}
//           </tr>
//         </thead>
//         <tbody>
//           {paymentUpload.map((row) => (
//             <tr key={row.name}>
//               <td>{row.name}</td>
//               <td className="text-center">{row.y}</td>
//               <td className="text-end">{formatCurrency(row.totalAmount)}</td>
//               <td>
//                 <InputFactory
//                   type="MultipleFile"
//                   field="shareArray"
//                   saveFile={saveFileUseCase()}
//                   multi
//                   multiple
//                   onChange={(value) => handleFileChange(value, row)}
//                 />
//                 <button
//                   className="btn btn-link btn-sm me-2 mt-4"
//                   onClick={() => setViewBucket(row)}
//                   style={{
//                     backgroundColor: "#83c14a",
//                     color: "white",
//                     marginBottom: 12,
//                   }}
//                 >
//                   View
//                 </button>

//                 {viewBucket?.name === row.name && (
//                   <div className="bg-white p-4 rounded">
//                     <div className="d-flex flex-wrap gap-2">
//                       {Array.from(
//                         new Set(
//                           viewBucket.transactions.flatMap(
//                             (tx) => tx.shareArray || []
//                           )
//                         )
//                       ).map((url, i) => (
//                         <div key={i} style={{ position: "relative" }}>
//                           <img
//                             src={url}
//                             className="img-thumbnail"
//                             alt={`Thumbnail ${i + 1}`}
//                             style={{
//                               width: 100,
//                               height: 100,
//                               objectFit: "cover",
//                               cursor: "pointer",
//                             }}
//                             onClick={() => setZoomSrc(url)}
//                           />
//                           <button
//                             onClick={() => handleDeleteRequest(url, viewBucket)}
//                             style={{
//                               position: "absolute",
//                               top: 2,
//                               right: 2,
//                               background: "rgba(255,255,255,0.8)",
//                               border: "none",
//                               borderRadius: "50%",
//                               width: 20,
//                               height: 20,
//                               padding: 0,
//                               cursor: "pointer",
//                             }}
//                           >
//                             ×
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                     <button
//                       className="btn btn-secondary mt-3"
//                       onClick={() => setViewBucket(null)}
//                     >
//                       Close
//                     </button>
//                   </div>
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );

// export default PaymentSummary;

import React from "react";
import InputFactory from "../../../../../components/InputFactory";
import { saveFileUseCase } from "../../../../../usecases/file";

// Constants
const CURRENCY_FORMAT_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

// Helper functions
const formatCurrency = (amount) =>
  `₱${Number(amount || 0).toLocaleString(undefined, CURRENCY_FORMAT_OPTIONS)}`;

const PaymentSummary = ({
  paymentDate,
  filteredData,
  paymentUpload,
  handlePaymentDateChange,
  handleFileChange,
  setViewBucket,
  viewBucket,
  handleDeleteRequest,
  setZoomSrc,
}) => (
  <div className="mt-5">
    {/* Header Section */}
    <div
      style={{
        marginBottom: "24px",
        paddingBottom: "16px",
        borderBottom: "2px solid #e5e7eb",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "-2px",
          left: 0,
          width: "80px",
          height: "2px",
          background: "linear-gradient(90deg, #1F4D2C 0%, #83c14a 100%)",
        }}
      ></div>

      <div className="row g-3 align-items-end">
        <div className="col-12 col-lg-8">
          <div className="d-flex align-items-center gap-3">
            <div
              className="d-none d-sm-flex"
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #1F4D2C 0%, #83c14a 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(31, 77, 44, 0.25)",
                flexShrink: 0,
              }}
            >
              <i
                className="bi bi-credit-card"
                style={{ color: "#ffffff", fontSize: "1.5rem" }}
              ></i>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <h4
                className="mb-0 fw-bold"
                style={{
                  color: "#1F4D2C",
                  fontSize: "clamp(1.25rem, 4vw, 1.5rem)",
                  fontFamily: "Inter, sans-serif",
                  letterSpacing: "-0.02em",
                }}
              >
                Payment Type Summary
              </h4>
              <p
                className="mb-0 d-none d-md-block"
                style={{
                  color: "#6b7280",
                  fontSize: "0.9rem",
                  fontFamily: "Inter, sans-serif",
                  marginTop: "2px",
                }}
              >
                Revenue breakdown by payment method
              </p>
            </div>
          </div>
        </div>

        {/* Date Filter */}
        <div className="col-12 col-sm-6 col-lg-4">
          <label
            style={{
              display: "block",
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#374151",
              marginBottom: "6px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            Filter by Date
          </label>
          <div style={{ position: "relative" }}>
            <span
              style={{
                position: "absolute",
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6b7280",
                pointerEvents: "none",
                fontSize: "1rem",
                zIndex: 1,
              }}
            >
              <i className="bi bi-calendar3"></i>
            </span>
            <input
              className="form-control shadow-none"
              type="date"
              value={paymentDate}
              disabled={filteredData.length === 0}
              onChange={handlePaymentDateChange}
              style={{
                height: "38px",
                paddingLeft: "40px",
                paddingRight: "12px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "0.9rem",
                fontFamily: "Inter, sans-serif",
                transition: "all 0.2s ease",
                backgroundColor:
                  filteredData.length === 0 ? "#f9fafb" : "#ffffff",
                width: "100%",
              }}
              onFocus={(e) => {
                if (filteredData.length > 0) {
                  e.target.style.borderColor = "#1F4D2C";
                  e.target.style.boxShadow = "0 0 0 3px rgba(31, 77, 44, 0.1)";
                }
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>
      </div>
    </div>

    {/* Desktop Table View */}
    <div
      className="card border-0 d-none d-lg-block"
      style={{
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
      }}
    >
      <div className="table-responsive">
        <table
          className="table table-hover mb-0"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          <thead>
            <tr
              style={{
                background: "linear-gradient(135deg, #1F4D2C 0%, #166534 100%)",
              }}
            >
              {[
                { label: "Payment Type", align: "left" },
                { label: "Count", align: "center" },
                { label: "Total Sales", align: "right" },
                { label: "Actions", align: "center" },
              ].map((header) => (
                <th
                  key={header.label}
                  className={`text-${header.align}`}
                  style={{
                    color: "#ffffff",
                    fontWeight: 600,
                    fontSize: "0.9rem",
                    padding: "16px 20px",
                    borderBottom: "none",
                    letterSpacing: "0.3px",
                  }}
                >
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paymentUpload.map((row, index) => (
              <React.Fragment key={row.name}>
                <tr
                  style={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fafb",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f0fdf4";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      index % 2 === 0 ? "#ffffff" : "#f9fafb";
                  }}
                >
                  <td
                    style={{
                      padding: "16px 20px",
                      fontWeight: 500,
                      color: "#1F4D2C",
                      fontSize: "0.95rem",
                      verticalAlign: "middle",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: "#83c14a",
                          flexShrink: 0,
                        }}
                      ></div>
                      {row.name}
                    </div>
                  </td>
                  <td
                    className="text-center"
                    style={{
                      padding: "16px 20px",
                      color: "#374151",
                      fontSize: "0.9rem",
                      verticalAlign: "middle",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#dbeafe",
                        color: "#1e40af",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "0.85rem",
                        fontWeight: 600,
                      }}
                    >
                      {row.y}
                    </span>
                  </td>
                  <td
                    className="text-end"
                    style={{
                      padding: "16px 20px",
                      color: "#1F4D2C",
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      verticalAlign: "middle",
                    }}
                  >
                    {formatCurrency(row.totalAmount)}
                  </td>
                  <td
                    className="text-center"
                    style={{
                      padding: "16px 20px",
                      verticalAlign: "middle",
                    }}
                  >
                    <div className="d-flex gap-2 align-items-center justify-content-center flex-wrap">
                      <div style={{ position: "relative" }}>
                        <InputFactory
                          type="MultipleFile"
                          field="shareArray"
                          saveFile={saveFileUseCase()}
                          multi
                          multiple
                          onChange={(value) => handleFileChange(value, row)}
                        />
                      </div>
                      <button
                        className="btn btn-sm"
                        onClick={() => setViewBucket(row)}
                        style={{
                          background:
                            "linear-gradient(135deg, #1F4D2C 0%, #83c14a 100%)",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          padding: "8px 16px",
                          fontSize: "0.85rem",
                          fontWeight: 500,
                          transition: "all 0.2s ease",
                          boxShadow: "0 2px 4px rgba(31, 77, 44, 0.2)",
                          whiteSpace: "nowrap",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 8px rgba(31, 77, 44, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 2px 4px rgba(31, 77, 44, 0.2)";
                        }}
                      >
                        <i className="bi bi-eye me-1"></i>
                        View Files
                      </button>
                    </div>
                  </td>
                </tr>

                {/* Expanded View for Files */}
                {viewBucket?.name === row.name && (
                  <tr>
                    <td
                      colSpan="4"
                      style={{
                        padding: "24px",
                        backgroundColor: "#f9fafb",
                        borderTop: "2px solid #e5e7eb",
                      }}
                    >
                      <div
                        style={{
                          background: "#ffffff",
                          padding: "24px",
                          borderRadius: "12px",
                          border: "1px solid #e5e7eb",
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
                          <h6
                            className="mb-0 fw-semibold"
                            style={{
                              color: "#1F4D2C",
                              fontSize: "1rem",
                              fontFamily: "Inter, sans-serif",
                            }}
                          >
                            <i className="bi bi-images me-2"></i>
                            Uploaded Files (
                            {
                              Array.from(
                                new Set(
                                  viewBucket.transactions.flatMap(
                                    (tx) => tx.shareArray || [],
                                  ),
                                ),
                              ).length
                            }
                            )
                          </h6>
                          <button
                            className="btn btn-sm"
                            onClick={() => setViewBucket(null)}
                            style={{
                              backgroundColor: "#f3f4f6",
                              color: "#374151",
                              border: "none",
                              borderRadius: "8px",
                              padding: "6px 16px",
                              fontSize: "0.85rem",
                              fontWeight: 500,
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e5e7eb";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "#f3f4f6";
                            }}
                          >
                            <i className="bi bi-x-lg me-1"></i>
                            Close
                          </button>
                        </div>

                        {Array.from(
                          new Set(
                            viewBucket.transactions.flatMap(
                              (tx) => tx.shareArray || [],
                            ),
                          ),
                        ).length > 0 ? (
                          <div className="d-flex flex-wrap gap-3">
                            {Array.from(
                              new Set(
                                viewBucket.transactions.flatMap(
                                  (tx) => tx.shareArray || [],
                                ),
                              ),
                            ).map((url, i) => (
                              <div
                                key={i}
                                style={{
                                  position: "relative",
                                  borderRadius: "12px",
                                  overflow: "hidden",
                                  border: "2px solid #e5e7eb",
                                  transition: "all 0.2s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.borderColor = "#83c14a";
                                  e.currentTarget.style.transform =
                                    "scale(1.05)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.borderColor = "#e5e7eb";
                                  e.currentTarget.style.transform = "scale(1)";
                                }}
                              >
                                <img
                                  src={url}
                                  className="img-thumbnail"
                                  alt={`File ${i + 1}`}
                                  style={{
                                    width: 120,
                                    height: 120,
                                    objectFit: "cover",
                                    cursor: "pointer",
                                    border: "none",
                                  }}
                                  onClick={() => setZoomSrc(url)}
                                />
                                <button
                                  onClick={() =>
                                    handleDeleteRequest(url, viewBucket)
                                  }
                                  style={{
                                    position: "absolute",
                                    top: 4,
                                    right: 4,
                                    background: "rgba(239, 68, 68, 0.95)",
                                    color: "#ffffff",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: 28,
                                    height: 28,
                                    padding: 0,
                                    cursor: "pointer",
                                    fontSize: "1.2rem",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s ease",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      "#dc2626";
                                    e.currentTarget.style.transform =
                                      "scale(1.1)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "rgba(239, 68, 68, 0.95)";
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                  }}
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "40px 20px",
                              color: "#9ca3af",
                            }}
                          >
                            <i
                              className="bi bi-inbox"
                              style={{ fontSize: "3rem", marginBottom: "12px" }}
                            ></i>
                            <p
                              className="mb-0"
                              style={{
                                fontSize: "0.9rem",
                                fontFamily: "Inter, sans-serif",
                              }}
                            >
                              No files uploaded yet
                            </p>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Empty State */}
      {paymentUpload.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#9ca3af",
          }}
        >
          <i
            className="bi bi-inbox"
            style={{ fontSize: "4rem", marginBottom: "16px" }}
          ></i>
          <h6
            style={{
              fontSize: "1.1rem",
              fontWeight: 600,
              marginBottom: "8px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            No Payment Data Available
          </h6>
          <p
            className="mb-0"
            style={{
              fontSize: "0.9rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            Select a date range to view payment summaries
          </p>
        </div>
      )}
    </div>

    {/* Mobile/Tablet Card View */}
    <div className="d-lg-none">
      {paymentUpload.length > 0 ? (
        <div className="row g-3">
          {paymentUpload.map((row, index) => (
            <div key={row.name} className="col-12 col-md-6">
              <div
                className="card border-0"
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                  transition: "all 0.3s ease",
                  overflow: "hidden",
                }}
              >
                {/* Card Header */}
                <div
                  style={{
                    padding: "16px 20px",
                    background:
                      "linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%)",
                    borderBottom: "2px solid #f3f4f6",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: "#83c14a",
                        }}
                      ></div>
                      <h6
                        className="mb-0 fw-semibold"
                        style={{
                          color: "#1F4D2C",
                          fontSize: "1rem",
                          fontFamily: "Inter, sans-serif",
                        }}
                      >
                        {row.name}
                      </h6>
                    </div>
                    <span
                      style={{
                        backgroundColor: "#dbeafe",
                        color: "#1e40af",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "0.8rem",
                        fontWeight: 600,
                      }}
                    >
                      {row.y}
                    </span>
                  </div>
                </div>

                {/* Card Body */}
                <div style={{ padding: "20px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <small
                      style={{
                        color: "#6b7280",
                        fontSize: "0.85rem",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Total Sales
                    </small>
                    <span
                      style={{
                        color: "#1F4D2C",
                        fontSize: "1.1rem",
                        fontWeight: 700,
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      {formatCurrency(row.totalAmount)}
                    </span>
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <InputFactory
                      type="MultipleFile"
                      field="shareArray"
                      saveFile={saveFileUseCase()}
                      multi
                      multiple
                      onChange={(value) => handleFileChange(value, row)}
                    />
                    <button
                      className="btn w-100"
                      onClick={() =>
                        setViewBucket(
                          viewBucket?.name === row.name ? null : row,
                        )
                      }
                      style={{
                        background:
                          viewBucket?.name === row.name
                            ? "#f3f4f6"
                            : "linear-gradient(135deg, #1F4D2C 0%, #83c14a 100%)",
                        color:
                          viewBucket?.name === row.name ? "#374151" : "#ffffff",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 16px",
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        transition: "all 0.2s ease",
                        boxShadow:
                          viewBucket?.name === row.name
                            ? "none"
                            : "0 2px 4px rgba(31, 77, 44, 0.2)",
                      }}
                    >
                      <i
                        className={`bi ${
                          viewBucket?.name === row.name ? "bi-x-lg" : "bi-eye"
                        } me-2`}
                      ></i>
                      {viewBucket?.name === row.name ? "Close" : "View Files"}
                    </button>
                  </div>
                </div>

                {/* Expanded Files Section */}
                {viewBucket?.name === row.name && (
                  <div
                    style={{
                      padding: "20px",
                      backgroundColor: "#f9fafb",
                      borderTop: "2px solid #e5e7eb",
                    }}
                  >
                    <h6
                      className="mb-3 fw-semibold"
                      style={{
                        color: "#1F4D2C",
                        fontSize: "0.95rem",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      <i className="bi bi-images me-2"></i>
                      Uploaded Files (
                      {
                        Array.from(
                          new Set(
                            viewBucket.transactions.flatMap(
                              (tx) => tx.shareArray || [],
                            ),
                          ),
                        ).length
                      }
                      )
                    </h6>

                    {Array.from(
                      new Set(
                        viewBucket.transactions.flatMap(
                          (tx) => tx.shareArray || [],
                        ),
                      ),
                    ).length > 0 ? (
                      <div className="d-flex flex-wrap gap-2">
                        {Array.from(
                          new Set(
                            viewBucket.transactions.flatMap(
                              (tx) => tx.shareArray || [],
                            ),
                          ),
                        ).map((url, i) => (
                          <div
                            key={i}
                            style={{
                              position: "relative",
                              borderRadius: "8px",
                              overflow: "hidden",
                              border: "2px solid #e5e7eb",
                            }}
                          >
                            <img
                              src={url}
                              className="img-thumbnail"
                              alt={`File ${i + 1}`}
                              style={{
                                width: 80,
                                height: 80,
                                objectFit: "cover",
                                cursor: "pointer",
                                border: "none",
                              }}
                              onClick={() => setZoomSrc(url)}
                            />
                            <button
                              onClick={() =>
                                handleDeleteRequest(url, viewBucket)
                              }
                              style={{
                                position: "absolute",
                                top: 2,
                                right: 2,
                                background: "rgba(239, 68, 68, 0.95)",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "50%",
                                width: 24,
                                height: 24,
                                padding: 0,
                                cursor: "pointer",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "30px 20px",
                          color: "#9ca3af",
                        }}
                      >
                        <i
                          className="bi bi-inbox"
                          style={{ fontSize: "2.5rem", marginBottom: "8px" }}
                        ></i>
                        <p
                          className="mb-0"
                          style={{
                            fontSize: "0.85rem",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          No files uploaded yet
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          className="card border-0"
          style={{
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              textAlign: "center",
              padding: "60px 20px",
              color: "#9ca3af",
            }}
          >
            <i
              className="bi bi-inbox"
              style={{ fontSize: "3.5rem", marginBottom: "16px" }}
            ></i>
            <h6
              style={{
                fontSize: "1rem",
                fontWeight: 600,
                marginBottom: "8px",
                fontFamily: "Inter, sans-serif",
              }}
            >
              No Payment Data Available
            </h6>
            <p
              className="mb-0"
              style={{
                fontSize: "0.85rem",
                fontFamily: "Inter, sans-serif",
              }}
            >
              Select a date range to view payment summaries
            </p>
          </div>
        </div>
      )}
    </div>
  </div>
);

export default PaymentSummary;
